import { Component, OnInit } from '@angular/core';

import {LoadingPage} from '../../../../shared/components/loading/loading.page.component';
import {LicenseService} from '../../../services/license.service';
import {NotificationService} from '../../../services/notification.service';

@Component({
    selector: 'itpx-evaluation-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.css']
})
export class EvaluationCoursesComponent extends LoadingPage implements OnInit {

    private tiles: Array<any>;

    constructor(
        private licenseService: LicenseService,
        private notificationService: NotificationService
    ) {
        super();
    }

    ngOnInit() {
        this.licenseService.getLicenses()
            .bindToLifecycle(this)
            .subscribe(
                body => this.buildTiles(body['data']),
                err => this.handleError(err)
            );
    }

    private buildTiles(data: Array<any>) {
        let tiles: any[] = data.map(t => {
            let isExam = t.productVariant && t.productVariant.product && t.productVariant.product.type == 'Exam';
            let target = null;
            /*t.type = 'certificate';*/
            if (isExam) target = '';
            else if (t.type == 'assignment') target = ['/evaluation/course/', t.id];
            else target = ['/#', t.id];

            let tile = {
                isExam: isExam,
                isCertificate: t.type == 'certificate',
                item: t,
                title: t.name,
                target:  target,
                description: t.information,
                icon: 'fa-book',
                color: 'grey',
                isClass: t.type == 'class',
                imageUrl: null,
                completionPercentage: t.completionPercentage,
                type: t.productVariant && t.productVariant.product ? t.productVariant.product.type : null,
            };

            if (!tile.isClass) {
                tile.imageUrl = t.productVariant.product.imageUrl;
            }

            return tile;
        });

        this.tiles = tiles;
        this.ready();
    }

    private handleError(error: any) {
        this.notificationService.error(error, 'Failed');
        this.ready();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/course/courses.component.ts